define.alias("ember-in-viewport/services/in-viewport", "calendar/services/in-viewport");